// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const PASSWORD_RESET_WE_SENT_YOU_NEW_TOKEN_CALL = "Vol\u00e1me ti znova a nadiktujeme ti nov\u00fd ov\u011b\u0159ovac\u00ed k\u00f3d.";
export const PASSWORD_RESET_WE_SENT_YOU_NEW_TOKEN_SMS = "Poslali jsme ti nov\u00fd ov\u011b\u0159ovac\u00ed k\u00f3d.";
export const PHONE_NUMBER_SAVED = "Telefonn\u00ed \u010d\u00edslo bylo ulo\u017een\u00e9.";
